import styled from 'styled-components';
import media from '../../../constants/media';
import { A } from '../../base/typography';

export const Top = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	display: flex;
	align-items: center;
	width: 100%;
	height: 6.5rem;
	padding: 0 3rem;
	overflow: hidden;
	color: ${({ theme }) => theme.colors.black};
	background-color: #ffffff;
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	transition: transform 150ms;
	transition-delay: 75ms;
	z-index: 2;

	${media.tabletOnly`
		padding: 0 1.5rem;
		font-size: 1.4rem;
		height: 5.5rem;
	`};

	${media.mobileOnly`
		padding: 0 1.5rem;
		min-height: 8.5rem;
	`};
`;

export const Image = styled.div`
	padding-top: 150%;
	background-image: url(${({ image }) => image.replace('crop', 'min')}&width=320&height=580);
	background-size: cover;
	background-position: 50% 50%;

	${media.mobileOnly`
		margin-top: 3rem;
	`};
`;

export const ImageText = styled.div`
	position: absolute;
	left: 2rem;
	bottom: 2rem;
	color: #fff;
	font-size: 2rem;
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	line-height: 1;
	opacity: 0;
	z-index: 3;
	pointer-events: none;
	transform: translate3d(0, 50%, 0);
	transition: transform 150ms, opacity 150ms;
	transition-delay: 75ms;
`;

export const ImageLinkText = styled.div`
	margin-top: 0.5rem;
	font-size: 1.5rem;
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
`;

export const WrapperLink = styled(A)`
	display: block;
	box-shadow: 0px 14px 34px rgba(0, 0, 0, 0.1);
	overflow: hidden;
	transition: transform 150ms, box-shadow 150ms;
	transition-delay: 75ms;
	${media.desktopSmall`
		&:hover {
			box-shadow: 0px 34px 54px rgba(0, 0, 0, 0.3);
			transform: scale(1.1);
			transform-origin: center;

			${Top} {
				transform: translate3d(0, -100%, 0);
			}
		}
	`}
`;

export const Wrapper = styled.div`
	position: relative;
	${media.desktopSmall`
		&:hover {
			${ImageText} {
				transform: translate3d(0, 0, 0);
				opacity: 1;
				transition-delay: 150ms;
			}
		}
	`}
`;
